/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const FormEntityStatus = {
  CONFIRMED: 'CONFIRMED',
  REQUIRE_SERVER_CONFIRMATION: 'REQUIRE_SERVER_CONFIRMATION',
};
